import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  MSALInstanceFactory,
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory,
} from '../utils/msal-utils';
import { RequireAuthenticatedUserGuard } from './guards/auth/require-authenticated-user.guard';
import { routes } from './app.routes';
import { ApplicationInsightsService } from './services/application-insights/application-insights.service';
import { AppInsightsErrorHandler } from './services/AppInsightsErrorHandler';
import { initializeGlobalState } from './services/global-state/global-state.initializer';

const providers = [
  // provideAnimations(), // TODO: It throws an error when this is included.
  RequireAuthenticatedUserGuard,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  provideHttpClient(withInterceptorsFromDi(), withInterceptors([])),
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes, withHashLocation()),
  ApplicationInsightsService,
  provideAppInitializer(initializeGlobalState),
  { provide: ErrorHandler, useClass: AppInsightsErrorHandler },
];

export const appConfig: ApplicationConfig = {
  providers,
};
